import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AppState } from "@redux/app-state";
// Best-effort server-side revocation of the refresh-token family on logout.
// A thunk (not the listener directly) so it can reach publicRepository via the
// thunk extraArgument. Never rejects: client-side logout must proceed even when
// the network call fails or no refresh token is stored.
//
// Takes the token as an argument rather than reading the cookie: the caller
// clears the cookies first (see the logout listener), so by the time this runs
// there is nothing left to read.
export const revokeRefreshToken = createAsyncThunk<void, string | null, { state: AppState; extra: Partial<Dependencies> }>(
  "users/revokeRefreshToken",
  async (refreshToken: string | null, { extra: { publicRepository } }) => {
    if (!refreshToken || !publicRepository) return;
    try {
      await publicRepository.logout(refreshToken);
    } catch {
      // ignore — best-effort
    }
  },
);
